import { Component, OnInit } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseFormFieldComponent } from "../base-form-field.component";
import { ItemStatus } from "src/services/item/item.interface";
import { EditableItemStatusValues, ItemStatusDisplay } from "src/services/item/item-display";

@Component({
  selector: "rc-item-status-form-field",
  templateUrl: "./item-status-form-field.component.html",
  styleUrls: ["./item-status-form-field.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ItemStatusFormFieldComponent,
    },
  ],
  standalone: false,
})
export class ItemStatusFormFieldComponent extends BaseFormFieldComponent<ItemStatus> implements OnInit {
  constructor() {
    super();
  }

  public async ngOnInit(): Promise<void> {
    this.fieldValue = this.initialValue;
    super.ngOnInit();
  }

  public async onInputChange(event: unknown): Promise<void> {
    const ionEvent = event as CustomEvent;

    const inputValue = ionEvent.detail.value;

    await this.onInputChangeInternal(inputValue);
  }

  protected async toDisplayValue(input: ItemStatus): Promise<string> {
    if (!input) {
      return "";
    }

    return input;
  }

  public itemStatusValues = EditableItemStatusValues;
  public itemStatusDisplay = ItemStatusDisplay;
}
